<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<!-- 			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.deviceNum" placeholder="设备编号/IMEI/MAC" >
					  <span slot="prepend">充电站</span>
					</Input>
			</FormItem> -->
			<FormItem prop="trackName" :label="this.$t('Station')" :label-width="100">
				<Select :placeholder="this.$t('Station')" style="width: 200px;" v-model="formInline.StationId">
					<Option :value=0>{{ this.$t('Common.All') }}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}
					</Option>
				</Select>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
		</Form>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getAlarmingInfoUrl" @listData='getDeviceData'></MyPage>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './ChargingInfoExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				getAlarmingInfoUrl: webapi.base_api_url + '/Operations/GetAlarmingInfo',
				loadingStatus: false,
				//
				params: "", //
				tableHeight: "650",
				
				BreadcrumbList: [this.$t('stationMonitoring'), '>>', this.$t('alarmMonitoring')],
				formInline: {
					StationId: 0
				},
				//Table Title Data
				columns1: [{
						title: this.$t('EquipmentNo'),
						key: 'EquipmentNo',
						minWidth: 120,
					}, {
						title: this.$t('EquipmentName'),
						key: 'EquipmentName',
						minWidth: 120,
					},
					{
						title: this.$t('ConnectorNo') ,
						key: 'ConnectorNo',
						minWidth: 120,
					},
					{
						title: this.$t('ConnectorName'),
						key: 'ConnectorName',
						minWidth: 120,
					},
					{
						title: this.$t('EquipmentType') ,
						key: 'EquipmentType',
						minWidth: 120,
						render: (h, params) => {
							return h('div', this.$options.filters.EquipmentTypeDesc(params.row.EquipmentType))
						}
					},
					{
						title: this.$t('ConnectorType'),
						key: 'ConnectorType',
						minWidth: 120,
						render: (h, params) => {
							return h('div', this.$options.filters.ConnectorTypeDesc(params.row.ConnectorType))
						
						}
					},
					{
						title: this.$t('WorkStatus'),
						key: 'WorkStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.WorkStatusDesc
							);
						}
					},
					{
						title: this.$t('Alarm'),
						key: 'AlarmCode',
						minWidth: 120,
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.AlarmCode) {
								case 0:
									color = "success",
										type = this.$t('StationMonitoring.NoAlarm')
									break;
								default:
									color = "error",
										type = params.row.AlarmDesc
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					
					{
						title: this.$t('StationMonitoring.CarCoupleStatus'),
						key: 'CarCoupleStatus',
						minWidth: 100,
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "error",
										type = this.$t('StationMonitoring.Disconnected')
									break;
								default:
									color = "success",
										type =this.$t('StationMonitoring.Connected') 
									break;
							}
							// return h('Tag', {
							// 		props: {
							// 			color: color
							// 		}
							// 	},
							// 	type
							// );
							return h('div', type);
						}
					},
					{
						title: this.$t('StationMonitoring.RatedPower') ,
						key: 'RatedPower',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.RatedPower)
						}
					}, {
						title: this.$t('StationMonitoring.ManufacturerName') ,
						key: 'ManufacturerName',
						minWidth: 120,
						tooltip: true,
					},
					{
						title: this.$t('StationName'),
						key: 'StationName',
						minWidth: 120,
						tooltip: true,
					},
					
				],
				data1: [],
				timer: ''
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {
		},
		activated() {
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); //Before the Vue instance is destroyed, clear our timer.
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const _this = this
			_this.handleSubmit();
		},
		beforeDestroy() {},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			
			show: function(type, params) {
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// 	const _this = this;
				// 	let parms = {
				// 		id: "params"
				// 	}
				// 	_this.$axios.post(webapi.base_api_url + "/Operations/GetAlarmingInfo", parms, {
				// 	}).then(res => {
				// 		console.log("res")
				// 		console.log(res.data)
				// 		if (res.data.Code == 0) {
				// 			_this.data1 = res.data.Data.AlarmingInfos;
				// 		}
				// 	})
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
